(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nav-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var button = event.target.closest('#NavDrawer .ft-mobile-nav__parent');
    if (!button) return;
    var panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel || !button.closest('#NavDrawer').contains(panel)) return;
    var expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;
  });
  } catch(e) { console.error(e); }
})();

})();
